import * as React from 'react';
import * as styles from './styles.css';
import { Tooltip, UIHeading2, UIHeading4, UIText1 } from '@cian/ui-kit';
import { IconFunctionalHelpCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { ConditionalWrapper } from '@cian/conditional-component';

type TDiffData = {
  text: string;
  icon: React.ReactElement | null;
};

interface ISupplyDemandParams {
  handleOpenTooltip(): void;
  marketType: string;
  marketTypeDescription: string;
  supplyDiffData: TDiffData;
  demandDiffData: TDiffData;
  isInfoOpen: boolean;
  handleOpenInfo(): void;
  isDesktop: boolean;
}
export function SupplyDemand({
  isDesktop,
  handleOpenTooltip,
  marketType,
  supplyDiffData,
  demandDiffData,
  isInfoOpen,
  handleOpenInfo,
  marketTypeDescription,
}: ISupplyDemandParams) {
  const tooltipContent = (
    <div data-testid="supplyDemandTitleTooltipId" className={styles['content']}>
      <div className={styles['content-item']}>
        <UIText1>Спрос — по числу просмотров на одно объявление в течение месяца.</UIText1>
      </div>
      <UIText1> Предложение — по числу объявлений в этом и соседних домах.</UIText1>
    </div>
  );

  return (
    <div data-testid="supplyDemandId" className={styles['container']}>
      <div className={styles['tooltip-container']}>
        <Tooltip
          onOpen={handleOpenTooltip}
          header="Как рассчитываем спрос и предложение"
          title={tooltipContent}
          theme="white"
          placement="bottom-end"
        >
          <div data-testid="supplyDemandTooltipOnOpenId" className={styles['tooltip-item']}>
            <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading4}>
              Динамика спроса и предложения
            </ConditionalWrapper>
            <IconFunctionalHelpCircle16 color="icon-secondary-default" />
          </div>
        </Tooltip>
      </div>
      <div className={styles['diff-content']}>
        <div className={styles['title']}>
          <UIHeading4>{marketType}</UIHeading4>
        </div>
        <div className={styles['diff-container']}>
          <div className={styles['diff-item']}>
            <UIText1 color="text-secondary-default">Спрос за год</UIText1>
            <div className={styles['diff-info']}>
              {demandDiffData.icon}
              <UIHeading2 color="text-main-default">{demandDiffData.text}</UIHeading2>
            </div>
          </div>
          <div className={styles['diff-item']}>
            <UIText1 color="text-secondary-default">Предложение за год</UIText1>
            <div className={styles['diff-info']}>
              {supplyDiffData.icon}
              <UIHeading2 color="text-main-default">{supplyDiffData.text}</UIHeading2>
            </div>
          </div>
        </div>
        <div className={styles['more-info']}>
          {!isDesktop && !isInfoOpen ? (
            <div
              onClick={handleOpenInfo}
              role="button"
              data-testid="supplyDemandMoreInfoBtnId"
              className={styles['more-btn']}
            >
              Что это значит
            </div>
          ) : (
            <UIText1>{marketTypeDescription}</UIText1>
          )}
        </div>
      </div>
    </div>
  );
}
